import { makeStyles } from '@material-ui/styles';
import React from 'react';
import styles from './PharmacyRequestsSummaryDetail.module.css';
import { MedicationCard, MedicationCardMode } from '../Components/MedicationCard';
import { ValidDateFormats } from '../Shared/DateUtilities';
import moment from 'moment-timezone';
import { ReadOnlyField } from '../Components/ReadOnlyField';
import { PharmacyRequestStatus } from '../Contracts/PharmacyRequestModels';
import { Tooltip } from '@material-ui/core';
import { ProfileIcon } from '../Components/Icons';
import { MedicationStatusIcon } from '../MedicationSummary/MedicationStatusIcon';
import { MedicationSummaryExpiryCard } from '../MedicationSummary/MedicationSummaryExpiryCard';
import { expiryStatusFromDate } from '../Shared/MedicationsHelpers';
var useStyles = makeStyles({
    pharmacyRequestItem: function (props) { return ({
        display: 'grid',
        padding: '6px 55px',
        gridTemplateColumns: props.columnWidths.card - 16 + "px " + props.columnWidths.orderInstructions + "px " + props.columnWidths.expires + "px",
        borderTop: '1px solid #D2D2D2',
        borderLeft: '3px solid #006AD2'
    }); }
});
export var PharmacyRequestsSummaryDetail = function (props) {
    var row = props.row;
    var computedStyles = useStyles(props);
    var updatedOnMoment = moment.utc(props.row.updatedOn).local();
    var updatedOn = updatedOnMoment.format(ValidDateFormats.PrettyPrintFullDateTimeWithBullet) + " by " + props.row.updatedBy;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.datestamp, title: updatedOn },
            React.createElement(ProfileIcon, { size: '16', noPadding: true }),
            React.createElement("span", { className: styles.info }, "Last updated: "),
            React.createElement("span", { className: styles.updatedText, "data-test-id": 'last-updated', onClick: props.onHistoryClicked }, updatedOn)),
        row.status === PharmacyRequestStatus.Cancelled && (React.createElement("div", { className: styles.cancelledReason },
            React.createElement(ReadOnlyField, { hideHelperText: true, multiLine: true, label: 'Cancellation reason' }, row.cancellationDetails.reason))),
        row.pharmacyRequestItems.map(function (it) { return (React.createElement("div", { key: it.id, className: computedStyles.pharmacyRequestItem },
            React.createElement("div", { className: styles.medication },
                React.createElement(MedicationStatusIcon, { medicationStatus: it.medicationStatus }),
                React.createElement("span", { className: styles.container },
                    React.createElement(MedicationCard, { name: it.name, strength: parseInt(it.strength), strengthUnit: it.strengthUnits, type: it.medicationType, mode: MedicationCardMode.SingleLine, size: it.packAmount, productPackAmount: it.productPackAmount, repeatsAmount: it.repeatsAmount, isNonStandardPackSize: it.isNonStandardPackSize, nonStandardPackSize: it.nonStandardPackSize }))),
            React.createElement("div", { className: styles.orderInstruction },
                React.createElement("span", { className: styles.containerLabel }, "Order instructions"),
                it.orderInstruction !== null && it.orderInstruction !== '' ? (React.createElement(Tooltip, { title: it.orderInstruction, placement: 'bottom-start' },
                    React.createElement("span", null, it.orderInstruction))) : (it.orderInstruction)),
            React.createElement("div", { className: styles.expiresOn },
                React.createElement("span", { className: styles.containerLabel }, "End date"),
                React.createElement("span", null,
                    React.createElement(MedicationSummaryExpiryCard, { selected: false, medicationExpiresOn: it.expiresOn, medicationExpiry: expiryStatusFromDate(it.expiresOn), medicationStatus: it.medicationStatus, isChartDuration: false }))))); })));
};
